import { motion } from 'framer-motion';

const ContactHero = () => {
  return (
    <section className="pt-32 pb-20 bg-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <h1 className="text-5xl lg:text-7xl font-extrabold text-white mb-6">
            Contacta con <span className="text-primary-yellow">Bala Corp</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Estamos aquí para ayudarte con tus necesidades legales. Responderemos tu consulta en menos de 24 horas.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactHero;